<template>
  <el-row v-if="!edit">
    <h3>
      <el-button
        v-show="!print"
        type="primary"
        icon="el-icon-edit"
        circle
        size="mini"
        @click="editMode"
      ></el-button>
      {{ form.name }}
      <span style="color:red;font-weight: 800">( 备注：{{ form.memo ? form.memo: "无"}} )</span>
    </h3>
    <br />
    <div>
      <el-row>
        <el-col :span="12">手机号码：{{ form.userInfoTeleNum }}</el-col>
        <el-col :span="12">出生日期：{{ form.birthDate | birthday }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12"> 年龄：{{ form.birthDate | age }}</el-col>
        <el-col :span="12">体重：{{ form.weight + " " + "公斤" }} </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"> 性别：{{ form.gender }}</el-col>
        <el-col :span="12"> 身高：{{ form.height + " " + "cm" }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12"> 单位：{{ form.company }}</el-col>
        <el-col :span="12"> 职务：{{ form.profession }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="12"> 地区：{{ form.address }}</el-col>
        <el-col :span="12"> 紧急联系人电话：{{ form.emergencyCall }}</el-col>
      </el-row>
    </div>
  </el-row>
  <!-- 用户未录入基础信息时 显示如下信息 -->
  <div v-else>
    <h3>修改基本信息</h3>
    <br />
    <el-form ref="form" :model="form" label-width="140px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="姓名：" required>
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号码：" required>
            <el-input v-model="form.userInfoTeleNum" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="性别：" required>
            <el-select v-model="form.gender" placeholder="请选择性别.">
              <el-option label="男" value="男"></el-option>
              <el-option label="女" value="女"></el-option>
            </el-select>
            <!-- <el-input v-model="form.gender"></el-input> -->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身高/cm：" required>
            <el-input v-model="form.height"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="地区：" required>
            <!-- <el-input v-model="form.address"></el-input> -->
            <el-select v-model="form.address" placeholder="请选择性别.">
              <el-option label="长沙" value="长沙"></el-option>
              <el-option label="重庆" value="重庆"></el-option>
              <el-option label="珠海" value="珠海"></el-option>
              <el-option label="上海" value="上海"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="体重/kg：" required>
            <el-input v-model="form.weight"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="出生日期：" required>
            <!-- <el-input v-model="form.birthDate"></el-input> -->
            <el-date-picker
              v-model="form.birthDate"
              type="date"
              placeholder="请选择您的出生日期..."
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>

            <!-- <el-date-picker
              v-model="form.birthDate"
              type="date"
              placeholder="请选择您的出生日期...">
            </el-date-picker> -->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="年龄：">
            <el-input :value="form.birthDate | age" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="单位：" required>
            <el-input v-model="form.company"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职务：" required>
            <el-input v-model="form.profession"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="紧急联系人信息：" required>
            <el-input v-model="form.emergencyCall"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注：" required>
            <el-input v-model="form.memo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-form-item>
          <el-button
            type="primary"
            style="width:100%"
            size="medium"
            @click="_updateUserInfo"
            >保存</el-button
          >
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import Moment from "moment";

import { getUser, updateUserInfo } from "../../api/userService";
export default {
  props: {
    teleNum: String,
    print: Boolean,
  },
  data() {
    return {
      //被检测人基础信息
      edit: false,
      form: {},
      // registered: false,
    };
  },
  methods: {
    editMode() {
      this.edit = true;
    },
    //获取用户基本信息
    _getUserInfo() {
      getUser(this.teleNum).then((res) => {
        console.log("ClientBasciInfo", res.data[0].userInfo);
        if (res.data[0].userInfo) {
          //基本信息
          this.form = res.data[0].userInfo;
          this.form.birthDate = Moment(this.form.birthDate).format(
            "YYYY-MM-DD"
          );
          this.edit = false;
        } else {
          this.edit = true;
        }
      });
    },
    _updateUserInfo() {
      let formatForm = Object.assign({}, this.form);
      formatForm.birthDate = Moment(formatForm.birthDate).format(
        "YYYY-MM-DD HH:MM:SS"
      );
      formatForm.weight = parseFloat(formatForm.weight);
      formatForm.height = parseFloat(formatForm.height);
      // console.log("form",this.form);
      console.log("formatForm", formatForm);
      // console.log(JSON.stringify(this.form));
      updateUserInfo(JSON.stringify(formatForm))
        .then((res) => {
          if (res.success) {
            //更新用户信息显示
            this.edit = false;
          } else {
            //如果接口调用失败则 告知用户错误信息
            this.$message({ type: "error", message: res.description });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  created() {
    this._getUserInfo();
  },
  filters: {
    age(value) {  
      const today = new Date();  
      const birthDate = new Date(value);  
      let age = today.getFullYear() - birthDate.getFullYear();  
      const monthDiff = today.getMonth() - birthDate.getMonth();  
      const dayDiff = today.getDate() - birthDate.getDate();  

      // Adjust the age if the birth month/day hasn’t occurred this year  
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {  
        age--;  
      }  

      return age + "岁";  
    },
    birthday(value) {
      let time = new Date(value);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return year + "年" + month + "月" + day + "日";
    },
  },
};
</script>

<style scoped lang="less">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.pad {
  padding-left: 20px;
}

.redColor {
  color: red;
}
</style>
